import { Component, ChangeDetectionStrategy, Input } from '@angular/core';
import { NOT_AVAILABLE, UNKNOWN } from '../../../../common/constants/template.constant';
import { TransportMode } from '../../../../common/constants/transport-mode';
import { LoadPrimary } from '../../../../store/state/monitoring/transport/models/transport-list.model';
import { DISPLAY_DATE_FORMAT } from '../../../../common/constants/date-config';
import { MonitoringPageType } from '../../../../store/state/monitoring/constants';
import { IconNames } from '../../../../common/constants';
import { DeviationType } from '../../../../store';
import { MonitoringStatus, DateType } from '../../../../store/constants';
import { Origin } from '../../../../store/state/monitoring/transport/constants';

@Component({
  selector: 'ui-load-card',
  templateUrl: './load-card.component.html',
  styleUrls: ['./load-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LoadCardComponent {
  @Input() load: LoadPrimary;
  @Input() monitoringPageType: MonitoringPageType;

  notAvailable = NOT_AVAILABLE;
  unknown = UNKNOWN;
  dateFormat = DISPLAY_DATE_FORMAT;
  monitoringStatus = MonitoringStatus;
  transportMode = TransportMode;
  deviationType = DeviationType;
  dateType = DateType;
  origin = Origin;
  iconNameList = IconNames;
}
